import { ChangeDetectorRef, Component, Inject, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingService } from './core/services/loading.service';
import { LoadingDialogComponent } from './shared/components/loading-dialog/loading-dialog.component';
import { LoadingIndicator } from './shared/components/loading/loading-indicator.model';
import { LoadingStepsEnum } from './shared/components/loading/loading-steps.enum';
import { HttpCoreService } from './core/services';
import { Brands } from './shared/enums/brands.enum';
import { DOCUMENT } from '@angular/common';
import { ResourceFilter } from './shared/models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class AppComponent {
  loadingDialogRef: MatDialogRef<LoadingDialogComponent>;
  locale: string = "";
  domain: string = "";
  brand: string = "";
  tenantCode: string = "";
  isLoaded: boolean = false;
  urlTmp: string;
  constructor(@Inject(DOCUMENT) private document: any, private loadingService: LoadingService, private httpService: HttpCoreService,
    public dialog: MatDialog) {

    sessionStorage.removeItem("resources");
    this.isLoaded = false;

    this.listenForLoading();

    this.urlTmp = window.location.href;
    var url = new URL(window.location.href.replace('#/', ''));

    this.locale = url.searchParams.get("locale");
    // let sessionLocale = JSON.parse(sessionStorage.getItem("locale"));

    // if (!this.locale && sessionLocale && sessionLocale != '') {
    //   this.locale = sessionLocale;
    // }

    if (this.locale && (this.locale.toLowerCase() == 'en-GB'.toLowerCase() || this.locale.toLowerCase() == 'fr-FR'.toLowerCase()
      || this.locale.toLowerCase() == 'en-US'.toLowerCase() || this.locale.toLowerCase() == 'es-ES'.toLowerCase()
      || this.locale.toLowerCase() == 'de-DE'.toLowerCase() || this.locale == '***')) {
      sessionStorage.setItem("locale", JSON.stringify(this.locale));
    }
    else {
      sessionStorage.setItem("locale", JSON.stringify(""));
      this.locale = '';
    }

    //this is for test environment
    // if(this.document.location.hostname.split(".")[2] == "org") {
    //   this.domain = "schoolscreenerforschools";
    // }
    // else {
    //   this.domain = "schoolscreener";
    // }

    //this is for production environment
    let domainStr: string = this.document.location.hostname.split(".")[1];
    if (domainStr != "workscreener" && domainStr != "cityscreener" && domainStr != "schoolscreenerforschools") {
      this.domain = "schoolscreener";
    }
    else {
      this.domain = domainStr;
    }


    this.setBrandName(this.domain);

    let brand: Brands = JSON.parse(sessionStorage.getItem("brand"));
    const favIcon = document.createElement('link');

    if (brand == Brands.SchoolScreenerForSchools) {
      favIcon.innerHTML = '<link id="favicon" type="image/x-icon" href="assets/schoolscreenerforschools/favicon.ico" rel="icon">';
    }
    else if (brand == Brands.WorkScreener) {
      favIcon.innerHTML = '<link id="favicon" type="image/x-icon" href="assets/workscreener/favicon.ico" rel="icon">';
    }
    else if (brand == Brands.CityScreener) {
      favIcon.innerHTML = '<link id="favicon" type="image/x-icon" href="assets/cityscreener/favicon.ico" rel="icon">';
    }
    else {
      favIcon.innerHTML = '<link id="favicon" type="image/x-icon" href="assets/schoolscreener/favicon.ico" rel="icon">';;
    }
    const head = document.head;
    while (favIcon.firstChild) {
      head.appendChild(favIcon.firstChild);
    }

    let filter: ResourceFilter = { culture: this.locale != '' && this.locale != null ? this.locale : 'en-GB', domainName: '', tenantCode: this.tenantCode ? this.tenantCode : '', branding: this.brand };
    this.httpService.services.resources.getTextResources(filter).subscribe({
      next: (data: any) => {
        sessionStorage.setItem("resources", JSON.stringify(data));
        this.isLoaded = true;
      },
      error: (error) => {
        console.error("Failed to load text resources", error);
        sessionStorage.setItem("resources", JSON.stringify({}));
        this.isLoaded = false;
      }
    });
  }

  ngOnInit() {
    this.urlTmp = window.location.href;

    if (this.urlTmp.toLocaleLowerCase().startsWith('https://app.schoolscreener.com/portal/#/zzthomsonnhs/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'dmo999.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/swindon/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'swi003.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/gloucestershire/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'glo004.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/villavision/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'vil005.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/5555/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'uhd015.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/ealing/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'eal007.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/pennine/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'pen042.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/forestschoolorg/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'for040.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/oxleas/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'oxl014.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/lewisham/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'lew028.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/3434/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'mer008.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/hrgy/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'har011.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/bolton/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'bol017.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/homertonhospital/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'hom025.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/brent/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'bre020.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/towerhamlets/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'tow038.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/worcestershire/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'wor012.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/ehealth/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'evh024.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/buckinghamshire/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'buc043.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/cnwlor/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'oas022.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/jaheedkhan/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'shc026.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/bromley/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'bro018.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/36378/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'wnr009.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/kent/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'ken027.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/thamesmead/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'tha035.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/cnwlmk/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'mil023.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/391732/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'cam019.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/southend/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'sen037.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/546/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'hnf021.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/medway/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'med029.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/bury/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'bur032.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/hmr1/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'hmr033.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/salford/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'sal034.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/hnr/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'sli036.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/3232/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'kes013.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/barnet/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'bar016.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/1234567789/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'nel031.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/compassukwarwickshire/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'cfh010.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/wforest/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'wal039.schoolscreener.com');
    }
    else if (this.urlTmp.toLocaleLowerCase().includes('https://app.schoolscreener.com/portal/#/newham/')) {
      window.location.href = this.urlTmp.replace('app.schoolscreener.com', 'new030.schoolscreener.com');
    }
  }

  setBrandName(domainName: string) {
    if (domainName == 'schoolscreenerforschools') {
      this.brand = Brands.SchoolScreenerForSchools;
    }
    else if (domainName == 'workscreener') {
      this.brand = Brands.WorkScreener;
    }
    else if (domainName == 'cityscreener') {
      this.brand = Brands.CityScreener;
    }
    else {
      this.brand = Brands.SchoolScreener;
    }
    sessionStorage.setItem("brand", JSON.stringify(this.brand));
  }



  listenForLoading() {
    this.loadingService.loadingStep.subscribe((step: LoadingStepsEnum) => {
      if (step == LoadingStepsEnum.Loading) {
        let loading: LoadingIndicator = {
          step: LoadingStepsEnum.Loading
        };

        this.openLoadingDialog(loading);
      }
      else if (step == LoadingStepsEnum.Content) {
        this.closeLoadingDialog();
      }
    });
  }

  private openLoadingDialog(loadingIndicator: LoadingIndicator) {
    if (this.loadingDialogRef) {
      return;
    }

    this.loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
      width: "120px",
      height: "120px",
      data: loadingIndicator,
      autoFocus: false,
      panelClass: "base-dialog",
      disableClose: true
    });
  }

  private closeLoadingDialog() {
    if (this.loadingDialogRef) {
      this.loadingDialogRef.close();
      this.loadingDialogRef = null;
    }
  }
}
